import React from 'react';
import RiskOverviewSectionHeader from '../RiskOverviewSectionHeader/RiskOverviewSectionHeader';
import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';
import { CurlyBraceDivider } from '/src/Components/CurlyBraceDivider/CurlyBraceDivider';
import GetImpactAcrossTimeText from '/src/services/Content/GetImpactAcrossTimeText';

import './style.css';

const HowToThinkAbout = ({ propertyData, title }) => {

    const how_to_think_intro_text = "When it comes to our homes, you need to think about climate change as a <i>financial</i> threat. Homes can be fixed, entire properties rebuilt, but the <i>costs</i> of climate's impact are going to be what decides whether a given home is a good investment or a financial weight. We're going to not only explain which climate risks to focus on for this home, we'll also connect the dots to explain the physical and financial costs you need to understand and solve for."
    // const how_to_think_intro_text = "It is easy to think about climate change through a physical lens, but when it comes to our homes, you need to think about it as a <i>financial</i> threat. Homes can be fixed, entire properties rebuilt, but the <i>costs</i> of that impact are going to be what decides whether a given home is a good investment or a financial weight. This analysis will not only explain which climate risks to focus on, we'll actually translate those threats into the physical and financial impacts you need to understand."
    const icons = [
        "general-climate-risks-icon.png",
        "squiggly-line.png",
        "house-wallet-icon.png"
    ]

    const impactAcrossTimeOptions = [
        {
            id: 1,
            icon: 'broken-home-green.png',
            timeframe: 'Sudden',
            title: 'Unforeseen Fixes',
            description: "Costs you may not have budgeted for."
        },
        {
            id: 2,
            icon: 'home_bills.png',
            timeframe: 'Recurring',
            title: 'General Expenses',
            description: 'Think insurance, maintenance, taxes, utilities etc.'
        },
        {
            id: 3,
            icon: 'home-ltv-icon.png',
            timeframe: 'Long-Term',
            title: 'Market Value',
            description: 'What happens when you go to sell the property?'
        }
    ]


    return (
        <div className="tab-content-container">
            <RiskOverviewSectionHeader title={title} />
            <div className="how-to-think-content-container">

                <div className="how-to-think-icons">
                    {/* <div className="how-to-think-icons-risk-to-impact-container">
                        {icons.map((icon, index) => (
                            <div key={index} className="how-to-think-icon-wrapper">
                                <img
                                    src={CreateCloudfrontUrl(icon)}
                                    alt=""
                                    className="how-to-think-icon"
                                />
                            </div>
                        ))}
                    </div>
                    <CurlyBraceDivider direction="left" color="grey" /> */}
                    <div className="how-to-think-impact-across-time-options-container">
                        {impactAcrossTimeOptions.map((option, index) => (
                            <div key={index} className="how-to-think-impact-across-time-option">
                                <div className="how-to-think-impact-across-time-option-timeframe-container">
                                    <span>{option.timeframe}</span>
                                </div>
                                <div className="how-to-think-impact-across-time-option-icon-wrapper">
                                    <img src={CreateCloudfrontUrl(option.icon)} alt={option.title} />
                                </div>
                                <div className="how-to-think-impact-across-time-option-text-wrapper">
                                    <span className="how-to-think-impact-across-time-option-title">{option.title}</span>
                                    <span className="how-to-think-impact-across-time-option-description text-align-center">{option.description}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <p className="text-align-center" dangerouslySetInnerHTML={{ __html: how_to_think_intro_text }} />
            </div>
        </div>
    );
};

export default HowToThinkAbout;
